// src/funciones/calcularComponentesExamen.js

import {
	collection,
	getDocs
} from "firebase/firestore";

import { db } from "../firebase/firebaseConfig";

const calcularDominioTema = (
	ultimosResultados = []
) => {

	const total =
		ultimosResultados.length;

	if (total === 0) {

		return {
			dominio: null,
			estado: "sin_datos",
			muestras: 0
		};
	}

	if (total < 5) {

		return {
			dominio: null,
			estado: "explorando",
			muestras: total
		};
	}

	const correctas =
		ultimosResultados.filter(
			r => r === true
		).length;

	const dominio =
		Math.round(
			(correctas / total) * 100
		);

	return {
		dominio,
		estado: null,
		muestras: total
	};
};

const obtenerEstado = (
	dominio,
	temasExplorados,
	temasEvaluados
) => {

	if (temasExplorados === 0) {
		return "sin_datos";
	}

	if (temasEvaluados === 0) {
		return "explorando";
	}

	if (temasEvaluados < 3) {
		return "explorando";
	}

	if (dominio >= 70) {
		return "estable";
	}

	if (dominio >= 50) {
		return "inestable";
	}

	return "critico";
};

const calcularComponentesExamen =
async (userId) => {

	const [
		progresoSnap,
		temaCompSnap,
		componentesSnap,
		examenesSnap
	] = await Promise.all([

		getDocs(
			collection(
				db,
				"progreso_temas"
			)
		),

		getDocs(
			collection(
				db,
				"tema_componente"
			)
		),

		getDocs(
			collection(
				db,
				"componentes"
			)
		),

		getDocs(
			collection(
				db,
				"examenes"
			)
		)
	]);

	const progresos =
		progresoSnap.docs
			.map(d => d.data())
			.filter(
				d =>
				d.userId === userId
			);

	const temaComponentes =
		temaCompSnap.docs.map(
			d => d.data()
		);

	const componentes =
		componentesSnap.docs.map(
			d => d.data()
		);

	const examenes =
		examenesSnap.docs.map(
			d => d.data()
		);

	const resultado = {};

	// crear estructura base

	examenes.forEach(examen => {

		resultado[examen.ID] = {

			examen:
				examen.Examen,

			componentes: {}
		};
	});

	// inicializar componentes

	componentes.forEach(comp => {

		if (
			!resultado[
				comp.ExamenID
			]
		) {
			return;
		}

		resultado[
			comp.ExamenID
		]
		.componentes[
			comp.Componente
		] = {
			id: comp.ID,
		
			dominios: [],

pesoTotal:0,

pesoAcumulado:0,

temasExplorados:0,

temasEvaluados:0
		};
	});

	// recorrer temas respondidos

	progresos.forEach(progreso => {

		const infoTema =
			calcularDominioTema(
				progreso
					.ultimosResultados
			);

			const relaciones =

			temaComponentes.filter(
		
				t =>
		
					Number(t.TemaID) ===
		
					Number(progreso.temaId) &&
		
					Number(t.Activo) === 1
		
			);
		
		if (!relaciones.length) {
		
			return;
		
		}
		
		relaciones.forEach(
		
			relacion => {
		
				const componentId =
		
					Number(relacion.Componentes);

				const componente =
					componentes.find(
						c =>
						Number(c.ID) ===
						Number(
							componentId
						)
					);

				if (
					!componente
				) {
					return;
				}

				const peso =

    Number(relacion.Peso || 1);

				resultado[
					componente.ExamenID
				]
				.componentes[
					componente.Componente
				]
				.temasExplorados += 1;

				resultado[
					componente.ExamenID
				]
				.componentes[
					componente.Componente
				]
				.pesoTotal += peso;

				if (
					infoTema.dominio !== null
				) {
				
					resultado[
						componente.ExamenID
					]
					.componentes[
						componente.Componente
					]
					.dominios
					.push(
						infoTema.dominio
					);
				
					resultado[
						componente.ExamenID
					]
					.componentes[
						componente.Componente
					]
					.temasEvaluados += 1;
				}
			});
	});

	// promediar

	Object.values(
		resultado
	).forEach(examen => {

		Object.values(
			examen.componentes
		).forEach(comp => {

			if (
				comp.temasEvaluados === 0
			) {
			
				comp.dominio =
					null;
			
			} else {

				comp.dominio =
					Math.round(

						comp.dominios
						.reduce(
							(a,b)=>
							a+b,
							0
						)

						/

						comp.dominios
						.length
					);
			}

			comp.estado =
				obtenerEstado(
					comp.dominio,
					comp.temasExplorados,
					comp.temasEvaluados
				);

			delete comp.dominios;
		});
	});

	return resultado;
};

export default
	calcularComponentesExamen;